import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { ClusterViewComponent } from './cluster-view/cluster-view.component';
import { ClusterService } from './cluster.service';
import { ClusterEditComponent } from './cluster-edit/cluster-edit.component';
import { FormsModule } from '@angular/forms';
import { ComponentsModule } from '@fi-app/components/components.module';
import { ClusterModel } from './cluster.model';
import { ClusterListComponent } from './cluster-list/cluster-list.component';
import { ClusterViewContainerComponent } from './cluster-view-container/cluster-view-container.component';
import { UIRouterModule } from '@uirouter/angular';
import { FiClusterStates } from '@fi-app/cluster/cluster-states';
import { MatTabsModule } from '@angular/material/tabs';
import { FiPageHeaderButtonGroupModule } from '@fi-shared/fi-page-header-button-group/fi-page-header-button-group.module';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { MatCardModule } from '@angular/material/card';
import { FiItemsListModule } from '@fi-shared/fi-items-list/fi-items-list.module';
import { FiLocalSearch2Module } from '@fi-shared/fi-local-search2/fi-local-search2.module';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { BusinessUnitModule } from '@fi-app/business-unit/business-unit.module';

@NgModule({
    imports: [
        CommonModule,
        UtilitiesModule,
        FormsModule,
        ComponentsModule,
        UIRouterModule.forChild(FiClusterStates),
        MatTabsModule,
        FiPageHeaderButtonGroupModule,
        FiPageHeaderModule,
        MatCardModule,
        FiItemsListModule,
        FiLocalSearch2Module,
        FiWrapperTableModule,
        BusinessUnitModule,
    ],
    declarations: [ClusterViewComponent, ClusterEditComponent, ClusterListComponent, ClusterViewContainerComponent],
    providers: [ClusterService, ClusterModel],
})
export class ClusterModule {}
